import * as actionTypes from "./AccountModeModalActionTypes";
import { Dispatch, UnknownAction } from "redux";

export const openAccountModeModalAction = () => (dispatch: Dispatch<UnknownAction>) => {
  dispatch({ type: actionTypes.ACCOUNT_MODE_MODAL_OPEN });
};
